import { TabView } from 'primereact/tabview';
import "./styles/TabZal.scss";
const TabZal = (props) => {
    // const [activeIndex, setActiveIndex] = useState(null);
    // const handleTab =(index)=>{
    //     setActiveIndex(index)
    //     props.cambiarAccion(index)


    // }
    // useEffect(() => {
    //     setActiveIndex(props.indexDefault)
    // }, [props.indexDefault]);
    return (
        <TabView {...props} activeIndex={props.activeIndex} className={props.tipo == "primary" ? "zal-tabview" : "zal-tabview-secondary"}
        //onTabChange={(e) => handleTab(e.index)}
        >
            {/* {props.children.map((item,i)=>{
                return(item)
            })} */}
        </TabView>
    );
}

export default TabZal;